import { Switch, Route, withRouter } from 'react-router-dom';
import Overview from './Overview';
import GenerateInvoice from './GenerateInvoice';

const DashboardRouter = ({ match }) => {

  const { path } = match

  return (
    <Switch>
      <Route path={`${path}/overview`}><Overview /></Route>
      <Route path={`${path}/generate-invoice`}><GenerateInvoice /></Route>
    </Switch>
  )
}

export default withRouter(DashboardRouter)
